import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import SourceURLField from '../../form-fields/upload/source-url'
import { CreationToolUploadContext } from '../manager'

const SourceURL = styled(SourceURLField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadSourceURLField = ({ className, field }: Props) => {
    const { sourceUrl, setSourceUrl } = useContext(CreationToolUploadContext)

    return (
        <SourceURL
            {...{
                className,
                field,
                sourceUrl,
                showInstructions: true,
                onChange: setSourceUrl,
            }}
        />
    )
}

export default CreationUploadSourceURLField
